import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "../BoardAuth";

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/board");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0a0a0a] px-6" data-testid="board-login">
      <div className="w-full max-w-md">
        <div className="mb-10 text-center">
          <div className="mb-4 flex items-center justify-center gap-2 text-champagne">
            <ShieldCheck size={22} strokeWidth={1.4} />
            <span className="text-xs uppercase tracking-[0.4em]">VR-Cockpit</span>
          </div>
          <h1 className="font-serif text-4xl font-light text-white">MYSYMP Board</h1>
          <p className="mt-3 text-sm text-white/45">Sicherer Zugang für Verwaltungsratsmandate</p>
        </div>
        <form onSubmit={submit} className="space-y-5 border border-white/10 bg-[#121212] p-8">
          <div>
            <label className="mb-1.5 block text-xs uppercase tracking-wider text-white/50">E-Mail</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-white/15 bg-black/30 px-3 py-3 text-sm text-white outline-none focus:border-champagne" />
          </div>
          <div>
            <label className="mb-1.5 block text-xs uppercase tracking-wider text-white/50">Passwort</label>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-white/15 bg-black/30 px-3 py-3 text-sm text-white outline-none focus:border-champagne" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-red-400">{error}</p>}
          <button data-testid="login-submit" disabled={loading}
            className="w-full bg-champagne py-3.5 text-xs uppercase tracking-[0.25em] text-obsidian transition-colors hover:bg-champagne-light disabled:opacity-50">
            {loading ? "Anmeldung…" : "Anmelden"}
          </button>
        </form>
        <p className="mt-6 text-center text-xs text-white/30">Vertraulich · Zugriffe werden protokolliert</p>
      </div>
    </div>
  );
};

export default Login;
